import { BrowserModule, HammerModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MaterialModule } from "./bancreachwebsite/material/material.module";
import { LightboxModule } from "ngx-lightbox";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { apiList } from "./bancreachwebsite/services/http/api-list";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { Constant } from "./bancreachwebsite/core/constant";
import { HttpInterceptorService } from "./bancreachwebsite/services/interceptor/http-interceptor.service";
import {
  NgxUiLoaderModule,
  NgxUiLoaderService,
} from "ngx-ui-loader";
import { NgxPaginationModule } from "ngx-pagination";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { ConfirmationModalComponent } from "./bancreachwebsite/modal/confirmation-modal/confirmation-modal.component";
import { ImagePreviewComponent } from "./bancreachwebsite/modal/image-preview/image-preview.component";
import { ImageCroppingComponent } from "./bancreachwebsite/modal/image-cropping/image-cropping.component";
import { MessagesService } from "./bancreachwebsite/pages/messages/messages.service";
// import { PinchZoomModule } from "ngx-pinch-zoom";
import { PostViewComponent } from "./bancreachwebsite/modal/post-view/post-view.component";
import { SharedModule } from "./bancreachwebsite/shared/shared.module";
import { MentionModule } from "angular-mentions-v2";
import { environment } from '../environments/environment';
import { ReportModalComponent } from "./bancreachwebsite/modal/report-modal/report-modal.component";
import { MarketUserComponent } from "./bancreachwebsite/modal/market-user/market-user.component";
import { HelpCenterComponent } from "./bancreachwebsite/modal/help-center/help-center.component";
import { SharelinkComponent } from "./bancreachwebsite/modal/sharelink/sharelink.component";
import { ServiceWorkerModule } from '@angular/service-worker';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { SlickCarouselModule } from "ngx-slick-carousel";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerRegisterService } from "./bancreachwebsite/services/service-worker-intializer/service-worker-register.service";
import { AgmCoreModule } from '@agm/core';
import { InfiniteScrollModule } from "ngx-infinite-scroll";


//Initial Service
export function startupServiceFactory(
  InitialService: ServiceWorkerRegisterService
): Function {
  return () => InitialService.publicApi();
}
@NgModule({
    declarations: [
        AppComponent,
        ConfirmationModalComponent,
        ImagePreviewComponent,
        PostViewComponent,
        ImageCroppingComponent,
        ReportModalComponent,
        MarketUserComponent,
        HelpCenterComponent,
        SharelinkComponent,
        // LinkifyPipe,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgxIntlTelInputModule,
        FormsModule,
        CommonModule,
        NgxUiLoaderModule,
        NgxPaginationModule,
        GooglePlaceModule,
        SlickCarouselModule,
        LightboxModule,
        InfiniteScrollModule,
        // PinchZoomModule,
        SharedModule,
        MentionModule,
        AgmCoreModule.forRoot({
          apiKey: environment.googleApiKey,
          libraries: ['drawing', 'places', 'geometry'],
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
        }),
        ShareButtonsModule.withConfig({
          debug: true,
        }),
        HammerModule,
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideAuth(() => getAuth()),

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        MessagesService,
        NgxUiLoaderService,
        apiList,
        Constant,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
